import "../styles/globals.css";
import type { AppProps } from "next/app";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ThemeProvider } from "@material-ui/core/styles";
import themeDark from "utils/themeDark";
import themeLight from "utils/themeLight";
import useDarkMode from "use-dark-mode";
function MyApp({ Component, pageProps }: AppProps) {
  const { value: isDark } = useDarkMode(true);
  return (
    // <ThemeProvider theme={isDark ? themeDark : themeLight}>
    <Component {...pageProps} />
  );
}

export default MyApp;
